import React from 'react'

const PlayfairCipherAlgo = () => {
    return (
        <div>
            <h3>Key Square Creation:</h3>
            <ol>
                <li>The key square is a 5x5 grid of alphabets that acts as the key for encrypting the plaintext. Each of the 25 alphabets must be unique and one letter of the alphabet (usually J) resides in the same cell as 'I'.</li>
                <li>The initial alphabets in the key square are the unique alphabets of the key in the order in which they appear followed by the remaining letters of the alphabet in order.</li>
            </ol>
            <br/>
            <h3>Encryption:</h3>
            <ol>
                <li>Split the plaintext first into digraphs (pairs of two letters). If the plaintext has an odd number of letters, append the letter 'Z' at the end. For example, MANGO will turn into MANGOZ.</li>
                <li>Replace all 'J's with 'I's as both resides in the same cell. </li>
                <li>For any letter that appears twice, place an 'X' after first letter. For plaintext GREET, the digraph will be GR EX ET.</li>
                <li><span style={{ fontWeight: "bold" }}>Rules for encryption :</span>
                    <ol type='a' style={{ marginLeft: 30 }}>
                    <li><span style={{fontWeight:"bold", color:"blue"}}>If both the letters are in the same column :</span> Take the letter below each one (going back to the top if at the bottom).</li>
                        <li><span style={{ fontWeight: "bold", color: "blue" }}>If both the letters are in the same row :</span> Take the letter on the right of each one (going back to the leftmost if at the rightmost position).</li>
                        <li><span style={{ fontWeight: "bold", color: "blue" }}>If neither of the above rules are true :</span> Form a rectangle with the two letters as corners and take the letters on the horizontal opposite corner of the rectangle.</li>
                    </ol>
                </li>
            </ol>
            <br />

            <h3>Decryption:</h3>
            <ol>
                <li>Divide the cipher text into digraphs (pairs of two letters).</li>
                <li><span style={{ fontWeight: "bold" }}>Rules for decryption :</span>
                    <ol type='a' style={{ marginLeft: 30 }}>
                        <li><span style={{ fontWeight: "bold", color: "blue" }}>If both the letters are in the same column :</span> Take the letter above each one (going back to the bottom if at the top).</li>
                        <li><span style={{ fontWeight: "bold", color: "blue" }}>If both the letters are in the same row :</span> Take the letter on the left of each one (going back to the rightmost if at the leftmost position).</li>
                        <li><span style={{ fontWeight: "bold", color: "blue" }}>If neither of the above rules are true :</span> Form a rectangle with the two letters as corners and take the letters on the horizontal opposite corner of the rectangle.</li>
                    </ol>
                </li>
            </ol>
        </div>

    )
}

export default PlayfairCipherAlgo